import { Component, ContentChild, TemplateRef } from '@angular/core';

import { AddBarDirective } from './../../directives';

@Component({
    selector: 'app-add-bar',
    templateUrl: './app-add-bar.component.html',
    styleUrls: ['./app-add-bar.component.scss']
})
export class AppAddBarComponent {
    @ContentChild(AddBarDirective, {read: TemplateRef}) addBarTemplate;

    hiddenClass = "add-bar-hidden";

    constructor() {

    }

    barToggler(open: boolean) {
        this.hiddenClass = open ? '' : 'add-bar-hidden';
    }
    
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-add-bar/app-add-bar.component.ts